module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/more-topic-5-mobile.819a9749.jpg";